import { h, render } from "preact";
import App from "./ui/App";

// Hydrate the app on the client side
render(<App />, document.getElementById("app")!);
